module.exports = __webpack_public_path__ + "fonts/exo-regular-webfont.3a5e6a25.woff";